import React, { useState } from "react";
import { get, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faClock,
  faCheckCircle,
  faParkingCircleSlash,
} from "@fortawesome/pro-light-svg-icons";
import {
  faSort,
  faArrowDown,
  faArrowUp,
} from "@fortawesome/pro-solid-svg-icons";
import { usCurrency } from "../../../../utils";
import moment from "moment";
import { AddToolTip } from "../../../../components";

const DetailsContainer = () => {
  return (
    <div className="trade-main-block">
      <div
        className="d-flex w-20"
        style={{ borderRight: "1px dashed #BDBDBD" }}
      >
        <div>
          {"Q1230232423".length > 30 ? (
            <AddToolTip name={"Q1230232423"}>
              <div className="main-font">
                {("Q1230232423" || "").slice(0, 30)}...
              </div>
            </AddToolTip>
          ) : (
            <div className="main-font">{"Q1230232423"}</div>
          )}
          <div className="status-trade-history">
            <FontAwesomeIcon icon={faCheckCircle} size="1x" />
            <div className="status-font-trade">Completed</div>
          </div>
        </div>
      </div>
      <div className="w-20">
        <div className="below-font">{"Transaction Type"}</div>
        <div className="minimal-font">{"Withdrawal"}</div>
      </div>

      <div className="w-20">
        <div className="below-font">{"Plan ID"}</div>

        <div className="minimal-font">{"09234143543"}</div>
      </div>

      <div className="w-20">
        <div className="below-font">{"SSN"}</div>

        <div className="minimal-font">{"AAA-DFE-EFES"}</div>
      </div>

      <div className="w-20">
        <div className="below-font">{"Trade Date"}</div>
        <div className="minimal-font">{"2/23/2021"}</div>
      </div>
    </div>
  );
};

const TradeCard = () => {
  return (
    <div className="trade-main-block">
      <div className="first-element-trade-inner" style={{ width: "20%" }}>
        <div className="investment-heading-trade-font">2345671</div>
        <div className="inner-text-trade">
          Buy
          <FontAwesomeIcon icon={faArrowUp} color="#1C7E18" />
        </div>
      </div>

      <div style={{ width: "14%" }}>
        <div className="minimal-font">{"Pre-tax"}</div>
      </div>

      <div style={{ width: "14%" }}>
        <div className="minimal-font">{78}</div>
      </div>

      <div style={{ width: "10%" }}>
        <div className="minimal-font">{200}</div>
      </div>

      <div style={{ width: "10%" }}>
        <div className="minimal-font">{24}</div>
      </div>
      <div style={{ width: "16%" }}>
        <div className="minimal-font">{"2/3/2021"}</div>
      </div>
      <div className="last-element-trade-inner" style={{ width: "16%" }}>
        <div className="inner-text-trade-status">
          <FontAwesomeIcon icon={faParkingCircleSlash} color="#F19937" />
          Awaiting Settlement
        </div>
      </div>
    </div>
  );
};
export const Trade = (props) => {
  return (
    <div className="transaction-history-withdrawal">
      <DetailsContainer />
      <div className="investment-heading-trade-font">Investment Details</div>
      <div className="minimal-font">{"08 files found"}</div>
      <div
        className="transaction-history-table"
        style={{ margin: "1rem 0 0.5rem 0" }}
      >
        <div className="header-transaction-history" style={{ width: "20%" }}>
          <div className="table-header-transaction-history">CUSIP</div>
          <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
        </div>
        <div
          className="header-transaction-history w-14"
          style={{ width: "14%" }}
        >
          <div className="table-header-transaction-history">Source</div>
          <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
        </div>
        <div
          className="header-transaction-history w-14"
          style={{ width: "14%" }}
        >
          <div className="table-header-transaction-history">Quantity</div>
          <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
        </div>
        <div
          className="header-transaction-history w-10"
          style={{ width: "10%" }}
        >
          <div className="table-header-transaction-history">Amount</div>
          <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
        </div>
        <div
          className="header-transaction-history w-10"
          style={{ width: "10%" }}
        >
          <div className="table-header-transaction-history">NAV</div>
          <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
        </div>
        <div
          className="header-transaction-history w-14"
          style={{ width: "16%" }}
        >
          <div className="table-header-transaction-history">Trade Date</div>
          <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
        </div>
        <div className="header-transaction-history " style={{ width: "16%" }}>
          <div className="table-header-transaction-history">Trade Status</div>
          <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" />
        </div>
      </div>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((_) => {
        return <TradeCard />;
      })}
    </div>
  );
};
